
const base64 = process.env.REACT_APP_DATA_ENCRYPTION_KEY;

function base64ToArrayBuffer() {
  if (!base64) {
    throw new Error('Encryption key is not set in environment variables.');
  }
  const binaryStr = atob(base64);
  const bytes = new Uint8Array(binaryStr.length);
  for (let i = 0; i < binaryStr.length; i++) {
    bytes[i] = binaryStr.charCodeAt(i);
  }
  return bytes.buffer;
}

function arrayBufferToBase64(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export async function encryptData(plainData: string) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoder = new TextEncoder();
  const keyBuffer = base64ToArrayBuffer();

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    "AES-GCM",
    false,
    ["encrypt"]
  );

  const encodedData = encoder.encode(plainData);
  const fullCipherBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv: iv },
    cryptoKey,
    encodedData
  );

  // 拆分 ciphertext 和 tag
  const fullCipherBytes = new Uint8Array(fullCipherBuffer);
  const tagLength = 16;
  const ciphertextBytes = fullCipherBytes.slice(0, fullCipherBytes.length - tagLength);
  const tagBytes = fullCipherBytes.slice(fullCipherBytes.length - tagLength);

  return {
    iv: arrayBufferToBase64(iv),
    ciphertext: arrayBufferToBase64(ciphertextBytes),
    tag: arrayBufferToBase64(tagBytes)
  };
}
